import scrollIntoFirstFormError from '../utils/scrollIntoFirstFormError';

export const REDUX_FORM_DEFAULT_CONFIG = {
  onSubmitFail: (errors) => errors && scrollIntoFirstFormError(errors),
};
